export default "__VITE_ASSET__BFu71zJP__"